export const TOGGLE_CLICKSIGN_VISIBLE = 'toggle_clicksign_visible'
export const CHANGE_CONFIG = 'change_config'

export function toggleVisible() {
  return {
    type: TOGGLE_CLICKSIGN_VISIBLE
  }
}

export function changeConfig(config) {
  return {
    type: CHANGE_CONFIG,
    payload: config,
  }
}
